var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 12.023C0.75 12.7192 1.02656 13.3869 1.51884 13.8792C2.01113 14.3714 2.67881 14.648 3.375 14.648C4.07119 14.648 4.73887 14.3714 5.23116 13.8792C5.72344 13.3869 6 12.7192 6 12.023C6 11.3268 5.72344 10.6591 5.23116 10.1669C4.73887 9.67457 4.07119 9.39801 3.375 9.39801C2.67881 9.39801 2.01113 9.67457 1.51884 10.1669C1.02656 10.6591 0.75 11.3268 0.75 12.023V12.023Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.023C18 12.3677 18.0679 12.7091 18.1998 13.0276C18.3317 13.346 18.5251 13.6354 18.7688 13.8792C19.0126 14.1229 19.302 14.3163 19.6205 14.4482C19.9389 14.5801 20.2803 14.648 20.625 14.648C20.9697 14.648 21.3111 14.5801 21.6295 14.4482C21.948 14.3163 22.2374 14.1229 22.4812 13.8792C22.7249 13.6354 22.9183 13.346 23.0502 13.0276C23.1821 12.7091 23.25 12.3677 23.25 12.023C23.25 11.6783 23.1821 11.3369 23.0502 11.0185C22.9183 10.7 22.7249 10.4106 22.4812 10.1669C22.2374 9.9231 21.948 9.72975 21.6295 9.59783C21.3111 9.46591 20.9697 9.39801 20.625 9.39801C20.2803 9.39801 19.9389 9.46591 19.6205 9.59783C19.302 9.72975 19.0126 9.9231 18.7688 10.1669C18.5251 10.4106 18.3317 10.7 18.1998 11.0185C18.0679 11.3369 18 11.6783 18 12.023V12.023Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.023C9.375 12.7192 9.65156 13.3869 10.1438 13.8792C10.6361 14.3714 11.3038 14.648 12 14.648C12.6962 14.648 13.3639 14.3714 13.8562 13.8792C14.3484 13.3869 14.625 12.7192 14.625 12.023C14.625 11.3268 14.3484 10.6591 13.8562 10.1669C13.3639 9.67457 12.6962 9.39801 12 9.39801C11.3038 9.39801 10.6361 9.67457 10.1438 10.1669C9.65156 10.6591 9.375 11.3268 9.375 12.023V12.023Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.89ca6ea0d08451562dba05c173e1ce61.svg";
export { ForwardRef as ReactComponent };